import { Button, Row, Col, Input, Label, FormGroup, FormFeedback } from "reactstrap";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { memo, useState } from "react"
import { useFormikContext } from 'formik';
import { isNonNegativeDecimal } from "../../utils/validation";
import useErrorHandler from "../../utils/Hooks/ErrorHandler";
import { FormLabel, FormValue } from '../Form/FormLabel';
import { endpoints } from "../../utils/Constants"
import { useAlert } from '../../Services/AlertContext';
import { useHistory } from 'react-router-dom';
import useFetchSimple from '../../Services/useFetchSimple';

const roundToTwo = (value) => Math.round(value * 100) / 100;
const formatToTwo = (value) => Number(roundToTwo(value)).toFixed(2);

const UpdateMargin = (props) => {

    const { values } = useFormikContext();
    const currentMargin = values.withMargin - values.price;
    const currentMarginRounded = roundToTwo(currentMargin);
    const { route, toggle } = { ...props };
    const [newMargin, setNewMargin] = useState(formatToTwo(currentMarginRounded));
    const { error, showError } = useErrorHandler(null);
    const alert = useAlert();
    const apiFetch = useFetchSimple();
    const [marginType, setMarginType] = useState("0")
    const isMarginTypePercent = marginType === "1";
    //const [state, dispatch] = useState(true);
    const { push } = useHistory();
    const closeBtn = (
        <button onClick={props.toggle} className="close" type="button">
            &times;
        </button>
    );

    const validatMargin = (
        margin
    ) => {
        // Validate margin
        if (!isNonNegativeDecimal(margin?.toString(), 2)) {
            showError("Please enter a valid margin (up to 2 decimals).");
            //setShowError(true)
            return false;
        }
        if (!isMarginTypePercent && roundToTwo(Number(margin)) === currentMarginRounded) {
            showError('Same Margin.')
            //setShowError(true)
            return false;
        }
        return true;
    };

    const handleSubmit = (e) => {

        e.preventDefault();
        //setLoading(true);
        if (validatMargin(newMargin)) {
            const normalizedMargin = roundToTwo(Number(newMargin));
            const post = {
                jobReference: values.jobReference,
                newMargin: normalizedMargin,
                oldMargin: currentMargin,
                id: values.id,
                bidHistoryId: values?.bid?.id,
                bidderId: values?.bid?.bidderId,
                marginType: marginType
            }
            apiFetch(endpoints.marginUpdateAdmin, {
                method: 'POST',              
                body: JSON.stringify(post)
            }).then((result) => {
                const isSuccess = Boolean(result?.body?.success);
                if (!isSuccess) {
                    console.warn('Margin update failed response', result?.body);
                }
                const saveMessage = isSuccess
                    ? `Margin Updated for JB${values.jobReference}`
                    : 'Error Occurred in Updating Margin';
                alert({
                    title: "Margin Update", body: <div>
                        {saveMessage}
                    </div>
                    , onDismiss: () => {
                        push(route);
                        toggle();
                    },
                    modalSize: "md"
                })

            }, (error) => {
                alert({ title: 'Margin Update', body: 'Error Occurred in Updating Margin', modalSize: "md" });
                console.log(error)
            })
            // props.toggle()
        }

        return false
    }

    const handleNewMarginChange = (e) => {
        const input = e.target.value;

        // Allow only non-negative numbers with up to two decimal places while typing.
        if (input === '' || /^\d*(\.\d{0,2})?$/.test(input)) {
            setNewMargin(input);
        }
    }

    const handleNewMarginBlur = () => {
        if (newMargin === '' || !isFinite(Number(newMargin))) {
            setNewMargin('0.00');
            return;
        }

        const clampedValue = Math.max(0, Math.min(isMarginTypePercent ? 100 : values.price, Number(newMargin)));
        setNewMargin(formatToTwo(clampedValue));
    }

    const onMarginTypeChange = (e) => {

        setMarginType(e.currentTarget.value)
        if (e.currentTarget.value === "0") {
            setNewMargin(formatToTwo(currentMarginRounded))
        }
        else
            setNewMargin('0.00')
    }

    return (
        <>
            <Modal isOpen={props.modal} toggle={toggle} backdrop={"static"} fade={false} unmountOnClose>
                <ModalHeader toggle={props.toggle} close={closeBtn} style={{ backgroundColor: 'lightblue' }}>
                    Update Margin for JB{values.jobReference}
                </ModalHeader>
                <ModalBody>

                    <Row>
                        <Col>
                            <FormGroup>
                                <FormLabel htmlFor="price" style={{ display: 'block' }}>Price</FormLabel>
                                <FormValue htmlFor="price" style={{ display: 'block' }}>{formatToTwo(values.price)}</FormValue>
                            </FormGroup>

                        </Col>
                        <Col>
                            <FormGroup>
                                <FormLabel htmlFor="withMargin" style={{ display: 'block' }}>WithMargin</FormLabel>
                                <FormValue htmlFor="withMargin" style={{ display: 'block' }}>{formatToTwo(values.withMargin)}</FormValue>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <FormLabel htmlFor="Margin" style={{ display: 'block' }}>Margin</FormLabel>
                                <FormValue htmlFor="Margin" style={{ display: 'block' }}>{formatToTwo(currentMargin)}</FormValue>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="align-items-center">
                        <Col md={4}>
                            <FormGroup>
                                <Label for="MarginType">
                                    <b> Margin Type</b>
                                </Label>
                                <Input
                                    id="MarginType"
                                    name="MarginType"
                                    type="select" value={marginType}
                                    onChange={onMarginTypeChange}  >
                                    <option value="0">
                                        Fixed
                                    </option>
                                    <option value="1">
                                        Percentage
                                    </option>

                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for="NewMargin">
                                    <b>New Margin</b>
                                </Label>
                                <Input invalid={error ? true : false} placeholder="Enter New Margin" id='NewMargin' name='NewMargin' type="text" inputMode="decimal"
                                    onBlur={handleNewMarginBlur}
                                    onChange={handleNewMarginChange} value={newMargin} />
                                <FormFeedback>
                                    {error}
                                </FormFeedback>
                            </FormGroup>
                        </Col>

                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleSubmit} >
                        Update
                    </Button>{' '}
                    <Button color="secondary" onClick={props.toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}
export default memo(UpdateMargin);